import React, { FC, useState } from "react";
import Button from "@material-ui/core/Button";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { DeleteSubscriptionDialog } from "../../DeleteSubscriptionDialog";

import { useStyles } from "./SubscriptionsSettingsActions.styles";
import { messages } from "./SubscriptionsSettingsActions.messages";
import { useSubscriptionEditProviderContext } from "../../../providers";

export const SubscriptionsSettingsActions: FC = () => {
  const {
    state: { savedSubscriptionItem, isCancelChangesDisabled, isDeleteDisabled, isUpdateDisabled },
    actions: { deleteSubscription, updateSubscription, cancelSubscriptionChanges },
  } = useSubscriptionEditProviderContext();

  const classes = useStyles();

  const [deleteSubscriptionsDialogOpen, setDeleteSubscriptionsDialog] = useState(false);

  return (
    <div className={classes.root}>
      <Button
        onClick={updateSubscription}
        disabled={isUpdateDisabled}
        color="primary"
        variant="contained"
        classes={{ root: classes.button }}
      >
        <FormattedMessage {...messages.save} />
      </Button>

      <Button
        onClick={cancelSubscriptionChanges}
        disabled={isCancelChangesDisabled}
        color="primary"
        variant="contained"
        classes={{ root: cn(classes.button, classes.cancelButton) }}
      >
        <FormattedMessage {...messages.cancel} />
      </Button>

      <Button
        onClick={() => setDeleteSubscriptionsDialog(true)}
        disabled={isDeleteDisabled}
        color="primary"
        variant="contained"
        classes={{ root: cn(classes.button, classes.deleteButton) }}
      >
        <FormattedMessage {...messages.delete} />
      </Button>

      {savedSubscriptionItem && (
        <DeleteSubscriptionDialog
          subscriptionItemName={savedSubscriptionItem.name}
          onDelete={() => {
            setDeleteSubscriptionsDialog(false);
            deleteSubscription();
          }}
          open={deleteSubscriptionsDialogOpen}
          handleCloseDialog={() => setDeleteSubscriptionsDialog(false)}
        />
      )}
    </div>
  );
};
